import { render, staticRenderFns } from "./CopyDocument.vue?vue&type=template&id=cf5ed3e2&scoped=true"
import script from "./CopyDocument.vue?vue&type=script&lang=js"
export * from "./CopyDocument.vue?vue&type=script&lang=js"
import style0 from "./CopyDocument.vue?vue&type=style&index=0&id=cf5ed3e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5ed3e2",
  null
  
)

export default component.exports